import { HttpClient, RequestParams } from "./base/BaseHttpClient";
import { FrontEndData } from "./contracts/models";

export class FrontEndDataApi<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags FrontEndData
   * @name Get
   * @request GET:/api/frontend
   * @response `200` `FrontEndData` OK
   */
  get = (params: RequestParams = {}) =>
    this.http
      .request<FrontEndData, any>({
        path: `/api/frontend`,
        method: "GET",
        credentials: "include",
        format: "json",
        ...params,
      })
      .then((m) => m.data);
}
